import Vue from 'vue'
import moment from 'moment'

Vue.filter('reverse', function (value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse()
})

Vue.filter('removeDashField', function (value) {
  return value.replaceAll(/_/ig, ' ').toUpperCase()
})

Vue.filter('numberFormat', function (value) {
  return Intl.NumberFormat().format(value)
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).fromNow()
  }
})

Vue.filter('formatDateVN', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDatetimeVN', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
})

Vue.filter('formatMoney', function (value, locale, currency) {
  var formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency

  // These options are needed to round to whole numbers if that's what you want.
  // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  })

  if (value) {
    return formatter.format(value)
  }
})
